export default __webpack_public_path__ + "static/media/cntr-tracking-rq-12-green.db735e38.svg";